import { combineReducers } from 'redux'

import app from './appReducer'
import vendor from './vendorReducer'

export default combineReducers({
  app,
  vendor
})



// WEBPACK FOOTER //
// ./src/redux/reducers.js